import { defineMessages } from 'react-intl';

export const freightInventoryWarningModalMessages = defineMessages({
  title: {
    id: 'P7wQxG',
    description: 'Title of the freight booking insufficient-inventory warning modal',
    defaultMessage: 'Inventory Warning',
  },
  cancel: {
    id: 'w+Y6Om',
    description: 'Label for the cancel button on the freight insufficient-inventory warning modal',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'e3ZLZ8',
    description: 'Label for the continue button that books the freight shipment despite insufficient inventory',
    defaultMessage: 'Continue',
  },
});
